import { render, staticRenderFns } from "./service-detail.vue?vue&type=template&id=541c8971&scoped=true"
import script from "./service-detail.vue?vue&type=script&lang=js"
export * from "./service-detail.vue?vue&type=script&lang=js"
import style0 from "./service-detail.vue?vue&type=style&index=0&id=541c8971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541c8971",
  null
  
)

export default component.exports